export const OKYANUS_LOGO =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_facade-hub-3/artifacts/qeothi9w_logo.png";

/** Company logo. `size` controls the rendered height in pixels. */
export function Logo({ size = 32, className = "", withWordmark = false }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="okyanus-logo">
      <img
        src={OKYANUS_LOGO}
        alt="Okyanus Grup"
        style={{ height: size }}
        className="w-auto object-contain"
      />
      {withWordmark ? (
        <span className="border-l border-slate-300 pl-3">
          <span className="font-display block text-sm font-semibold tracking-tight text-slate-900">
            OKYANUS HUB
          </span>
          <span className="mono block text-[10px] tracking-wider text-slate-500">
            okyanushub.com
          </span>
        </span>
      ) : null}
    </span>
  );
}
